import React from 'react'
import { useKeenSlider } from 'keen-slider/react'
import 'keen-slider/keen-slider.min.css'

export default function Animate() {
   const [sliderRef] = useKeenSlider(
      {
         loop: true,
         slides: {
            origin: 'center',
            perView: 1
         },
         vertical: true
      },
      [
         slider => {
            let timeout
            let mouseOver = false
            function clearNextTimeout() {
               clearTimeout(timeout)
            }
            function nextTimeout() {
               clearTimeout(timeout)
               if (mouseOver) return
               timeout = setTimeout(() => {
                  slider.next()
               }, 1000)
            }
            slider.on('created', () => {
               nextTimeout()
            })
            slider.on('dragStarted', clearNextTimeout)
            slider.on('animationEnded', nextTimeout)
            slider.on('updated', nextTimeout)
         }
      ]
   )

   return (
      <span ref={sliderRef} className='keen-slider programs_animate'>
         <span className='keen-slider__slide'>Full Stack Developer Job</span>
         <span className='keen-slider__slide'>Data Analyst Job</span>
         <span className='keen-slider__slide'>QA Engineer Job</span>
         <span className='keen-slider__slide'>Software Engineer Job</span>
      </span>
   )
}
